import { 
  IoLogoJavascript, 
  IoLogoDocker,
  IoLogoNodejs,
} from "react-icons/io5";

import {
  SiMocha,
  SiExpress,
  SiTypescript,
  SiMongodb,
} from "react-icons/si";

import {
  GrMysql,
} from "react-icons/gr";

import chaiLogo from '../Images/chai.svg';
import futebolClube from '../Images/trybe-futebol-clube.png';
import blogsApi from '../Images/blogs-api.png';
import carShop from '../Images/car-shop.png';
import trybeSmith from '../Images/trybesmith.png';
import storeManager from '../Images/store-manager.png';
import trybersDragons from '../Images/trybers-and-dragons.png';

const jwt = <img src="https://jwt.io/img/pic_logo.svg" className="skill-icon" alt="jwt-logo"/>;
const postgres = <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-plain.svg" className="skill-icon" alt="postgres-logo"/>
const sequelize = <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg" className="skill-icon" alt="sequelize-logo"/>;
const mongoose = <img src="https://mongoosejs.com/docs/images/mongoose5_62x30_transparent.png" alt="mongoose-logo" width="35px"/>
const chai = <img src={ chaiLogo } className="skill-icon" alt="chai-logo"/>;
const sinon = <img src="https://sinonjs.org/assets/images/logo.png" className="skill-icon" alt="sinon-logo" />;

const backProject = [
  {
    id: 1,
    name: 'trybe-futebol-clube',
    type: 'backend',
    img: futebolClube,
    description: `O Trybe Futebol Clube é um site informativo que fornece informações sobre partidas e classificações de futebol. Durante o desenvolvimento, foi criada uma API que se comunica com o front-end, permitindo adicionar uma partida após a validação de um token.`,
    development:
      <>
        <p>Trybe Futebol Clube é um projeto que fornece informações sobre um campeonato de futebol. Ele inclui um front-end pré-disponibilizado que permite realizar login e gerar um token.</p>
        <br/>
        <p>A API é capaz de acessar o banco de dados e retornar informações sobre todos os times, ou somente um time específico por meio do seu ID. Além disso, ela retorna informações sobre todas as partidas ou apenas as partidas em andamento ou finalizadas. A API possui endpoints para criar partidas em andamento, atualizar o placar e o status de progresso, e filtrar a classificação geral do campeonato, bem como a classificação dos times jogando em casa ou como visitantes.</p>
        <br/>
        <p>Para criar a aplicação, foi utilizado o Docker para criar três containers, sendo dois para o ambiente preparado para o Node.js (um para o front-end e outro para o back-end) e um terceiro para o banco de dados PostgreSQL. A aplicação foi escrita com o TypeScript e o Express.js para gerenciar rotas, tratar requisições HTTP e definir middlewares. O JWT foi usado para autenticar o token durante as requisições, e a biblioteca Sequelize foi utilizada como ORM para abstrair operações do PostgreSQL.</p>
        <br/>
        <p>Para a implementação de testes de integração, foram utilizadas as bibliotecas Mocha, Chai e Sinon, com uma cobertura de testes de aproximadamente 90% da aplicação back-end.</p>
      </>,
    challenges:
      <>
        <p>Durante o desenvolvimento desta API, surgiram algumas dificuldades. Inicialmente, eu utilizei a abordagem do Test Driven Development (TDD) e achei um pouco complicado essa forma de desenvolvimento. Acredito que com treino e prática, seja possível aperfeiçoar essa técnica, mas compreendi sua finalidade e acredito que ela deve se tornar um hábito no dia a dia de um programador.</p>
        <br/>
        <p>Também surgiram alguns problemas de lógica durante o projeto, mas consegui resolvê-los acessando o Stack Overflow, onde um desenvolvedor explicou com detalhes como funcionam as funções de ordenação do JavaScript. Assim, fiz adaptações e as apliquei ao meu código.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/trybe-futebol-clube',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'TypeScript',
        'Express.js',
        'JWT',
        'PostgreSQL',
        'Sequelize',
        'Mocha',
        'Chai',
        'Sinon',
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <SiTypescript className="skill-icon" color="#3178c6" />,
        <SiExpress className="skill-icon" color="grey"/>,
        jwt,
        postgres,
        sequelize,
        <SiMocha className="skill-icon" color="#8D6748"/>,
        chai,
        sinon,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
  {
    id: 2,
    name: 'blogs-api',
    type: 'backend',
    img: blogsApi,
    description: `O Blogs API é uma aplicação RESTful projetada para gerenciar o conteúdo de um blog. É possível criar, visualizar, atualizar e excluir posts, mediante autenticação para realizar as requisições.`,
    development:
      <>
        <p>O Blogs API é uma aplicação de gerenciamento de blogs que foi criada com JavaScript. Para rodar o código sem depender do navegador, o Docker foi utilizado com dois containers, sendo um para o Node.js e outro para o banco de dados PostgreSQL.</p>
        <br/>
        <p>O framework Express.js foi usado para gerenciar as rotas, tratar as requisições HTTP e definir middlewares. O JWT (JSON Web Token) foi utilizado para autenticar as requisições que necessitam de um token válido, que é gerado após o login. Além disso, a biblioteca Joi foi aplicada para validar os dados que são enviados através do corpo das requisições.</p>
        <br/>
        <p>A organização de diretórios adotada foi o modelo MSC (Model, Service e Controller) e o ORM (Object-Relational Mapping) Sequelize foi utilizado para interagir com o banco de dados, permitindo a definição de relacionamentos entre as tabelas.</p>
        <br/>
        <p>Os endpoints dessa aplicação são capazes de realizar operações CRUD (Create, Read, Update e Delete) nos dados.</p>
      </>,
    challenges:
      <>
        <p>Sem dúvida, o desafio mais significativo desta aplicação foi a configuração do Sequelize, já que este foi o meu primeiro projeto envolvendo o uso de um ORM. A sintaxe das migrations, seeders e models é diferente do que eu estava acostumado, mas o que mais me causou dificuldades foi a definição dos relacionamentos entre as tabelas, que achei um pouco confuso. No entanto, acredito que com mais prática esse processo se tornará mais simples.</p>
        <br/>
        <p>A documentação do Sequelize me foi muito útil na configuração, pois me permitiu me basear e adaptar para o meu código. Além disso, o MySQL Workbench também foi de grande ajuda, graças à sua interface gráfica, onde eu pude visualizar as tabelas já populadas com seus dados e verificar se os relacionamentos e tipos estavam corretos.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/blogs-api',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'JavaScript',
        'Express.js',
        'JWT',
        'PostgreSQL',
        'Sequelize',
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <IoLogoJavascript className="skill-icon" color="#F0DB4F"/>,
        <SiExpress className="skill-icon" color="grey"/>,
        jwt,
        postgres,
        sequelize,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
  {
    id: 3,
    name: 'car-shop',
    type: 'backend',
    img: carShop,
    description: `O Car Shop é uma API de gerenciamento de concessionárias que permite o gerenciamento de veículos, incluindo criação, leitura, atualização e exclusão. Foi utilizada a programação orientada a objetos para a construção dessa API.`,
    development:
      <>
        <p>O Car Shop é uma API projetada para gerenciar uma concessionária de veículos, com estruturas de dados distintas para carros e motos. O Docker foi usado para criar dois containers: um para o Node, responsável por executar o JavaScript fora do navegador, e outro para o banco de dados MongoDB.</p>
        <br/>
        <p>A linguagem utilizada para escrever a aplicação é o TypeScript, que é uma linguagem de tipagem estática. O Express.js gerencia as rotas, processa as requisições HTTP e define middlewares. A organização das pastas segue o modelo MSC (Model, Service, e Controller), aplicando princípios da programação orientada a objetos.</p>
        <br/>
        <p>O ODM Mongoose foi utilizado para modelar e manipular o banco de dados, e os endpoints da API permitem realizar as operações CRUD (Criar, Ler, Atualizar e Excluir). Para a implementação dos testes de unidade, foram usadas as bibliotecas Mocha, Chai e Sinon, com desenvolvimento orientado a testes (TDD), resultando em uma cobertura de aproximadamente 85% da camada Service.</p>
      </>,
    challenges:
      <>
        <p>O desafio foi encontrar a melhor forma de estruturar o código de acordo com os princípios da programação orientada a objetos, especialmente a abstração. Eu acredito que essa habilidade é algo que se aperfeiçoa com o tempo, pois pode ser complexa e variar de aplicação para aplicação. Continuarei treinando para melhorar minhas habilidades.</p>
        <br/>
        <p>A configuração do ODM Mongoose também foi uma novidade para mim, mas o material fornecido pela Trybe me ajudou na compreensão da sintaxe e configuração. A extensão Thunderclient também foi muito útil para simular requisições e verificar se o retorno estava de acordo com as expectativas, incluindo os códigos HTTP e a resposta JSON.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/car-shop',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'TypeScript',
        'Express.js',
        'MongoDB',
        'Mongoose',
        'Mocha',
        'Chai',
        'Sinon'
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <SiTypescript className="skill-icon" color="#3178c6" />,
        <SiExpress className="skill-icon" color="grey"/>,
        <SiMongodb className="skill-icon" color="#4DB33D" />,
        mongoose,
        <SiMocha className="skill-icon" color="#8D6748"/>,
        chai,
        sinon,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
  {
    id: 4,
    name: 'trybesmith',
    type: 'backend',
    img: trybeSmith,
    description: `TrybeSmith é uma loja de itens medievais em formato de API. Desenvolvemos as camadas da aplicação (Modelo, Serviço e Controlador), as operações de criação, leitura e atualização, bem como a autenticação de token para realizar as requisições.`,
    development:
      <>
        <p>TrybeSmith é uma API de comércio de itens medievais que permite o cadastro e listagem de produtos e pedidos, bem como o cadastro de usuários e a realização de login. Para sua execução, foi utilizado o Docker para criar dois containers, um para o Node.js que roda o JavaScript no back-end e outro para o ambiente do banco de dados MySQL.</p>
        <br/>
        <p>A linguagem escolhida para o desenvolvimento da aplicação foi o TypeScript, e o Express.js cuidou da gestão das rotas, tratamento das requisições HTTP e definição dos middlewares. Além disso, a biblioteca JWT foi utilizada para a autenticação do token durante as requisições e o Joi para as validações dos dados fornecidos via body. A estrutura da API segue o modelo MSC (Model, Service e Controller).</p>
      </>,
    challenges:
      <>
        <p>O desenvolvimento desta aplicação foi desafiador devido às diferenças do Typescript em relação ao JavaScript, já que este foi meu primeiro projeto utilizando esta linguagem. Foi preciso prestar atenção na definição das tipagens e na organização do código, a fim de criar as interfaces de forma eficiente e evitar repetições. Durante o processo, precisei buscar apoio na mentoria da Trybe para resolver questões sobre o retorno das models, mas, graças à ajuda dos instrutores, consegui desenvolver a aplicação com sucesso.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/trybesmith',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'TypeScript',
        'Express.js',
        'JWT',
        'MySQL',
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <SiTypescript className="skill-icon" color="#3178c6" />,
        <SiExpress className="skill-icon" color="grey"/>,
        jwt,
        <GrMysql className="skill-icon" color="#00758f" />,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
  {
    id: 5,
    name: 'store-manager',
    type: 'backend',
    img: storeManager,
    description: `Store Manager é uma API de gerenciamento de vendas em formato dropshipping, que permite a realização de operações CRUD (Create, Read, Update e Delete). A aplicação segue a arquitetura MSC.`,
    development:
      <>
        <p>Store Manager é uma API de sistema de gerenciamento de vendas no formato dropshipping, capaz de realizar operações de CRUD (Create, Read, Update e Delete) utilizando a arquitetura MSC. O uso do Docker permitiu a criação de dois containers: um para rodar o código JavaScript fora do navegador com o Node.js, e outro para disponibilizar o banco de dados MySQL para a aplicação.</p>
        <br/>
        <p>O projeto foi escrito em JavaScript, com o framework Express.js sendo utilizado para administrar as rotas, executar o tratamento das requisições HTTP e implementar os middlewares. A biblioteca Joi foi responsável por realizar as validações dos dados enviados no corpo das requisições.</p>
        <br/>
        <p>Os endpoints são capazes de realizar operações de CRUD tanto para vendas quanto para produtos. Para garantir a qualidade do código, foram escritos testes de unidade usando Mocha, Chai e Sinon, alcançando uma taxa de cobertura de 100% da aplicação. O desenvolvimento foi realizado com base no método de desenvolvimento orientado a testes (TDD).</p>
      </>,
    challenges:
      <>
        <p>Neste projeto, tive a oportunidade de praticar o uso do modelo MSC para organizar e estruturar a API. Consegui compreender bem o conceito desse modelo, mas enfrentei um pouco de dificuldade para lembrar as queries do MySQL, já que as escrevi manualmente sem utilizar nenhum ORM. Para superar essa dificuldade, consultei a documentação e revisei as aulas da Trybe, o que me permitiu avançar no projeto.</p>
        <br/>
        <p>Além disso, a implementação dos testes também foi um desafio, pois era necessário conhecer exatamente a forma de retorno do banco de dados para realizar os mocks. Nesse sentido, fiz amplo uso da extensão ThunderClient e dos console.logs.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/store-manager',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'JavaScript',
        'Express.js',
        'MySQL',
        'Mocha',
        'Chai',
        'Sinon'
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <IoLogoJavascript className="skill-icon" color="#F0DB4F"/>,
        <SiExpress className="skill-icon" color="grey"/>,
        <GrMysql className="skill-icon" color="#00758f" />,
        <SiMocha className="skill-icon" color="#8D6748"/>,
        chai,
        sinon,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
  {
    id: 6,
    name: 'trybers-and-dragons',
    type: 'backend',
    img: trybersDragons,
    description: `Trybers and Dragons é um projeto baseado na estrutura de jogos de interpretação de papéis (RPG). Foi implementado os princípios da arquitetura SOLID e de programação orientada a objetos (POO).`,
    development:
      <>
        <p>Trybe and Dragons é uma aplicação de jogo de RPG que permite criar personagens com raças e classes diferentes, cada um com suas próprias características, aumentar seu nível e melhorar seus atributos para ficar mais forte. É possível também criar dragões e monstros para simular batalhas entre personagens e contra monstros.</p>
        <br/>
        <p>O ambiente de desenvolvimento foi preparado com o Node.js usando o Docker, e o código foi escrito em TypeScript, uma linguagem com tipagem estática e forte.</p>
      </>,
    challenges:
      <>
        <p>Nesse projeto, eu tive a oportunidade de praticar os princípios da arquitetura SOLID e de programação orientada a objetos (POO). Na minha opinião, o assunto mais complexo no módulo de back-end é a aplicação correta do SOLID. Eu tive dificuldade em compreender os conceitos e especialmente em pensar na estruturação das classes de maneira a não violar os princípios.</p>
        <p>Acredito que somente a prática e um aprofundamento nos estudos podem aperfeiçoar essa técnica. Busquei ajuda na mentoria da Trybe com instrutores que me auxiliaram a pensar e a construir o código de maneira adequada.</p>
      </>,
    links: {
      repo: 'https://github.com/h3zord/trybers-and-dragons',
    },
    skills: {
      name: [
        'Docker',
        'Node.js',
        'TypeScript',
      ],
      icon: [
        <IoLogoDocker className="skill-icon" color="#0db7ed" />,
        <IoLogoNodejs className="skill-icon" color="#68a063" />,
        <SiTypescript className="skill-icon" color="#3178c6" />,
      ],
    },
    demonstration: {
      video: "",
      screenshots: [
      ]
    },
  },
]

export default backProject;